import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, } from "react";
import "./style.scss";
import { BiMove } from "@react-icons/all-files/bi/BiMove";
import MultiImageInput from "components/MultiImageInput";
import Well from "components/Well";
import FormSubtext from "../FormSubtext";
const MultiAssetUploader = ({ id, name, label, setValue, placeholder, defaultValue, onUploadingChange, ...inputProps }) => {
    const [images, setImages] = useState([]);
    const hasInitialisedFromDefault = useRef(false);
    const uploadMultiImage = (data) => {
        const image = { ...data };
        if (!(image === null || image === void 0 ? void 0 : image.id)) {
            image.id = image.key;
        }
        setImages((prevImages) => {
            const existsAlready = prevImages.some((img) => img.key === image.key);
            if (existsAlready) {
                return prevImages;
            }
            return [...prevImages, image];
        });
    };
    useEffect(() => {
        // Only seed from defaultValue once: the parent form may re-render (e.g. while the
        // submit mutation is loading) and rebuild this array from the pre-edit campaign update,
        // which would otherwise clobber any in-progress drag-and-drop reordering.
        if (defaultValue && !hasInitialisedFromDefault.current) {
            setImages(defaultValue);
            hasInitialisedFromDefault.current = true;
        }
    }, [defaultValue]);
    useEffect(() => {
        setValue(name, images);
    }, [images, name, setValue]);
    const deleteSelectedImage = (data) => {
        const currentImages = [...images];
        const deletedImageIndex = currentImages.findIndex((image) => image.key === data);
        if (deletedImageIndex > -1) {
            currentImages.splice(deletedImageIndex, 1);
            setImages(currentImages);
        }
    };
    const sendUpdatedImagesOrder = (data) => {
        setImages(data);
    };
    return (_jsxs("div", { className: "multi-image-uploader", children: [label && _jsx("label", { htmlFor: id !== null && id !== void 0 ? id : name, children: label }), inputProps.subtext && _jsx(FormSubtext, { text: inputProps.subtext }), _jsxs(Well, { style: {
                    display: "flex",
                    alignItems: "center",
                    padding: ".5rem",
                    fontSize: ".8rem",
                    marginTop: ".8rem",
                }, look: "brand-light", classes: "", children: [_jsx(BiMove, { fill: "#1fa8df", size: 30, style: { marginRight: "10px" } }), _jsx("span", { className: "reorder-subtext", children: "Click 'Add images' to upload. Once you have uploaded images, you can select and drag the images around to re-order them." })] }), _jsx(MultiImageInput, { ...inputProps, storedImgSrc: images, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "", onUpload: uploadMultiImage, type: "campaignImage", deleteSelectedImage: deleteSelectedImage, updateImagesOrder: sendUpdatedImagesOrder, onUploadingChange: onUploadingChange })] }));
};
export default MultiAssetUploader;
